
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../services/apiService';

const LoginPage: React.FC<{ onLogin: () => void }> = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const success = await apiService.login(username, password);
      if (success) {
        onLogin();
        navigate('/admin');
      } else {
        setError('Ongeldige combinatie van gebruikersnaam en wachtwoord.');
      }
    } catch (err) {
      setError('Er is een verbindingsfout opgetreden.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-6 relative overflow-hidden">
      {/* Background elements for premium feel */}
      <div className="absolute top-[-10%] right-[-10%] w-[40%] h-[40%] bg-primary/10 rounded-full blur-[120px]"></div>
      <div className="absolute bottom-[-10%] left-[-10%] w-[30%] h-[30%] bg-primary/5 rounded-full blur-[100px]"></div>
      
      <div className="w-full max-w-md relative z-10">
        <div className="bg-white/[0.03] backdrop-blur-xl border border-white/10 p-12 rounded-[2.5rem] shadow-2xl">
          <div className="text-center mb-10">
            <h1 className="font-display text-3xl text-white tracking-widest uppercase mb-2">MD Portal</h1>
            <p className="text-primary text-[10px] font-bold uppercase tracking-[0.3em]">Beveiligde Toegang</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label className="text-[10px] font-bold text-white/30 uppercase tracking-widest ml-1">Gebruikersnaam</label>
              <input 
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Admin"
                className="w-full bg-white/5 border-white/10 rounded-2xl px-6 py-4 text-white font-bold outline-none focus:border-primary transition-all text-center"
                required
              />
            </div>

            <div className="space-y-2">
              <label className="text-[10px] font-bold text-white/30 uppercase tracking-widest ml-1">Wachtwoord</label>
              <input 
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full bg-white/5 border-white/10 rounded-2xl px-6 py-4 text-white font-bold outline-none focus:border-primary transition-all text-center tracking-[0.5em]"
                required
              />
            </div>

            {error && (
              <div className="bg-red-500/10 border border-red-500/20 text-red-500 text-[11px] font-bold p-4 rounded-xl text-center uppercase tracking-wider animate-shake">
                {error}
              </div>
            )}

            <button 
              type="submit" 
              disabled={loading}
              className="w-full bg-primary hover:bg-white text-black py-5 rounded-2xl font-black uppercase tracking-[0.2em] transition-all shadow-xl shadow-primary/10 disabled:opacity-50 flex items-center justify-center gap-3"
            >
              {loading ? (
                <div className="w-5 h-5 border-2 border-black/20 border-t-black rounded-full animate-spin"></div>
              ) : 'Inloggen'}
            </button>
          </form>

          <button 
            onClick={() => navigate('/')}
            className="w-full mt-8 text-white/30 hover:text-white text-[10px] font-bold uppercase tracking-widest transition-colors flex items-center justify-center gap-2"
          >
            <span className="material-icons text-sm">arrow_back</span> Terug naar website
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
